export var rootpath = '/app';
/** コンテンツへのパス */
export var pathToContents = function (kind) { return rootpath + "/" + kind.toLowerCase() + "-contents"; };
/** 課題配付のコース情報JSONへのパス */
export var pathToAssignmentJson = function (kind) { return pathToContents(kind) + "/assignments/course-info.json"; };
/** サムネイルのフォルダへのパス */
export var pathToAssignmentThumbnail = function (kind, id) {
    return kind === 'MORAL' ? pathToMoralThumbnail(id) : pathToKeyboardThumbnail();
};
/** モラルのサムネイルフォルダへのパス */
export var pathToMoralThumbnail = function (id) { return pathToContents('MORAL') + "/images/" + id; };
/** キーボード練習のサムネイルフォルダへのパス */
export var pathToKeyboardThumbnail = function () { return pathToContents('KEYBOARD') + "/images/thumbnail"; };
